export const UrlParamKeys = {
  AuthenticationTypeOverride: 'auth',
  AuthSetting: 'authSetting',
  ClosePopupWhenDone: 'closePopupWhenDone',
  DeviceType: ':device',
  EditDataAlert: ':editDataAlert',
  ResumeDataAlert: ':resumeDataAlert',
  Embedded: 'embedded',
  FromFailureEmail: ':fromFailureEmail',
  FromSuccessEmail: ':fromSuccessEmail',
  FromSubscriptionEmail: 'fromSubscriptionEmail',
  RedirectSource: 'redirect_source',
  Redirect: 'redirect',
  ExternalRedirect: 'externalRedirect',
  IsFromSaml: ':isFromSaml',
  IsSevere: 'isSevere',
  Order: 'order',
  PublishedDataSources: 'publishedDataSources',
  RemoteAgentWorkflowId: 'remoteAgentWorkflowId',
  SiteLuid: 'siteLuid',
  SiteUrlName: 'siteUrlName',
  SyncAvailable: 'syncAvailable',
  SyncRunning: 'syncRunning',
  PublishedWithLQS : 'publishedWithLQS',
  PublishedDataSourcesWithLQS : 'publishedDataSourcesWithLQS',
  OriginalView : ':original_view',
  SuppressResumeMetricBanner: 'suppressResumeMetricBanner',
  LinkFromSlack: ':linkFromSlack',
  ShowComments: ':showComments',
  ClientAppId: 'clientAppId',
  IdpConfigurationId: 'idpConfigurationId',
  JobId: 'jobId',
  VpLoadTimestamp: ':vpLoadTimestamp',
  VpLoadType: ':vpLoadType'
};
